import React from 'react';
import PropTypes from 'prop-types';
import { CustomMoneyInputDaily } from '@src/components';

const DailyPriceDisabled = ({ totalPrice }) => {
  return (
    <>
      <CustomMoneyInputDaily
        value={totalPrice}
        width={88}
        height={40}
        disabled
      />
      <span className="info-text" style={{ fontSize: '12px' }}>TL</span>
    </>
  );
};

DailyPriceDisabled.propTypes = {
  totalPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DailyPriceDisabled;
